import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
} from '@mui/material';
import { NoEncryption as LockIcon } from '@mui/icons-material';

const AccessDenied = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <LockIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
          
          <Typography variant="h3" component="h1" gutterBottom color="error">
            {t('errors.access_denied', 'Access Denied')}
          </Typography>
          
          <Typography variant="h5" gutterBottom color="text.secondary">
            {t('errors.error_code', 'Error 403')}
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ maxWidth: 600, mb: 4 }}>
            {t('errors.access_denied_message', 'Sorry, you don\'t have permission to access this page. Please contact your administrator if you believe this is an error.')}
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              component={RouterLink}
              to="/dashboard"
            >
              {t('common.go_to_dashboard', 'Go to Dashboard')}
            </Button>
            
            <Button
              variant="contained"
              component={RouterLink}
              to="/login"
            >
              {t('auth.login', 'Login')}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied; 